import { createCommonjsModule, unwrapExports } from '../../../../../_virtual/_commonjsHelpers.js';

var log_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = log;

/*eslint no-console:0*/
function log() {
}
});

unwrapExports(log_1);

export { log_1 as __moduleExports };
